"use strict";

exports.__esModule = true;
exports.sizeWeightCombinationValidator = exports.sizeTypeCombinationValidator = void 0;

require("core-js/modules/es6.string.includes");

require("core-js/modules/es7.array.includes");

/* eslint-disable sort-keys-fix/sort-keys-fix */
var allWeights = ['semibold', 'regular', 'light', 'extra-light'];
var sizeWeightCombinations = {
  tiny: ['regular', 'semibold'],
  small: ['regular', 'semibold'],
  normal: ['regular', 'semibold'],
  medium: ['light', 'regular', 'semibold'],
  'medium-large': ['light'],
  large: ['light'],
  xlarge: ['extra-light'],
  xxlarge: ['extra-light']
};
var bodySizeWhitelist = ['tiny', 'small', 'normal', 'medium'];

var sizeTypeCombinationValidator = function sizeTypeCombinationValidator(props, propName, componentName) {
  if (props[propName]) {
    var size = props.size,
        type = props.type;
    var primitiveType = typeof props[propName];

    if (primitiveType !== 'string') {
      return new Error("Invalid prop `" + propName + "` of type `" + primitiveType + "` supplied to `" + componentName + "`, expected `string`.");
    }

    if (type === 'body' && !bodySizeWhitelist.includes(size)) {
      return new Error("The value of \"" + type + "\" on prop `type` cannot be used in combination with the value of \"" + size + "\" on prop `size` for " + componentName + ".");
    }
  }

  return undefined;
};

exports.sizeTypeCombinationValidator = sizeTypeCombinationValidator;

var sizeWeightCombinationValidator = function sizeWeightCombinationValidator(props, propName, componentName) {
  if (props[propName]) {
    var size = props.size;
    var weight = props[propName];
    var primitiveType = typeof props[propName];

    if (primitiveType !== 'string') {
      return new Error("Invalid prop `" + propName + "` of type `" + primitiveType + "` supplied to `" + componentName + "`, expected `string`.");
    }

    if (!weight || (sizeWeightCombinations[size] || allWeights).includes(weight)) {
      return undefined;
    }

    return new Error("The value of \"" + weight + "\" on prop `" + propName + "` cannot be used in combination with the value of \"" + size + "\" on prop `size` for " + componentName + ".");
  }

  return undefined;
};

exports.sizeWeightCombinationValidator = sizeWeightCombinationValidator;